if (!customElements.get("sticky-variant-select")) {
  customElements.define(
    "sticky-variant-select",
    class StickyProVariantSelect extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("change", this.onStickyVariantChange);
      }

      onStickyVariantChange() {
        this.varOptions = this.querySelector("select");
        //console.log("connected", this.varOptions.value);

        let productForms = document.querySelector(
          `#product-sticky-form-${this.dataset.section}`
        );
        let input = productForms.querySelector('input[name="id"]');
        input.value = this.varOptions.value;
      }
    }
  );
}

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    stickyScroll();
  });
  document.addEventListener("shopify:section:select", (event) => {
     stickyScroll();
  });
  document.addEventListener("shopify:section:deselect", (event) => {
     stickyScroll();
  });
}

function stickyScroll() {
  // Resolve the sticky bar and the purchase anchor on every update so the
  // listener still binds when either node is missing at init time, or is
  // added later (for example when the Shopify theme editor re-renders).
  const updateStickyCart = () => {
    let stickySelectedVariant = document.querySelector(`#sticky__variant`);
    if (stickySelectedVariant) {
      let stickySelectVairantInput = document.querySelector(
        "#sticky__selected_variant_id"
      );
      if (stickySelectVairantInput) {
        stickySelectVairantInput.value = stickySelectedVariant.value;
      }
    }

    const productStickyWrapper = document.querySelector(".product__sticky");
    if (!productStickyWrapper) return;

    const primaryPurchaseArea = document.querySelector("[data-primary-purchase-area]");
    if (!primaryPurchaseArea) return;

    const purchaseAreaPosition = primaryPurchaseArea.getBoundingClientRect();
    const shouldShow = purchaseAreaPosition.bottom < 0;

    productStickyWrapper.classList.toggle("sticky", shouldShow);
    productStickyWrapper.setAttribute("aria-hidden", String(!shouldShow));
    document.body.classList.toggle("sticky__cart", shouldShow);
  };

  updateStickyCart();
  window.addEventListener("scroll", updateStickyCart, { passive: true });
  window.addEventListener("resize", updateStickyCart);
}
stickyScroll();


